export default "__VITE_ASSET__DsXe7noT__"